export default __webpack_public_path__ + "static/media/Snd_LowerRSwim.68a9c8de.mp3";